import { render, staticRenderFns } from "./AccountingPrintTable.vue?vue&type=template&id=1fbb8e0a&scoped=true&"
import script from "./AccountingPrintTable.vue?vue&type=script&lang=js&"
export * from "./AccountingPrintTable.vue?vue&type=script&lang=js&"
import style0 from "./AccountingPrintTable.vue?vue&type=style&index=0&id=1fbb8e0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbb8e0a",
  null
  
)

export default component.exports